import FileDownload from "@mui/icons-material/FileDownload";
import { Menu, MenuItem, Tooltip } from "@mui/material";
import { ExportCsv, ExportPrint, ToolbarButton } from "@mui/x-data-grid-pro";
import type { FC } from "react";
import { useRef, useState } from "react";

export const ExportMenu: FC<{ hideText?: boolean }> = ({ hideText = false }) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Tooltip title="Export">
        <ToolbarButton
          ref={triggerRef}
          id="export-menu-trigger"
          aria-controls="export-menu"
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={() => setOpen(true)}
          size="small"
        >
          <FileDownload fontSize="inherit" />
          {!hideText && <>&#xA0; Export</>}
        </ToolbarButton>
      </Tooltip>
      <Menu
        id="export-menu"
        // eslint-disable-next-line react-hooks/refs
        anchorEl={triggerRef.current}
        open={open}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          list: {
            "aria-labelledby": "export-menu-trigger",
          },
        }}
      >
        <ExportCsv render={<MenuItem />}>Download as CSV</ExportCsv>
        <ExportPrint render={<MenuItem />}>Print</ExportPrint>
      </Menu>
    </>
  );
};
